//Quebec city
import quebec1 from '../../assets/quebec/quebec1.jpg';
import quebec2 from '../../assets/quebec/quebec2.jpg';
import quebec3 from '../../assets/quebec/quebec3.jpg';
import quebec1M from '../../assets/quebec/quebec1M.jpg';
import quebec2M from '../../assets/quebec/quebec2M.jpg';
import quebec3M from '../../assets/quebec/quebec3M.jpg';
//banff
import banff1 from '../../assets/banff/banff1.jpg';
import banff2 from '../../assets/banff/banff2.jpg';
import banff3 from '../../assets/banff/banff3.jpg';
import banff4 from '../../assets/banff/banff4.jpg';
import banff1M from '../../assets/banff/banff1M.jpg';
import banff2M from '../../assets/banff/banff2M.jpg';
import banff3M from '../../assets/banff/banff3M.jpg';
import banff4M from '../../assets/banff/banff4M.jpg';
//yukon
import yukon1 from '../../assets/yukon/yukon1.jpg';
import yukon2 from '../../assets/yukon/yukon2.jpg';
import yukon3 from '../../assets/yukon/yukon3.jpg';
import yukon1M from '../../assets/yukon/yukon1M.jpg';
import yukon2M from '../../assets/yukon/yukon2M.jpg';
import yukon3M from '../../assets/yukon/yukon3M.jpg';

export const carouselData = [
  [
    {
      photo: quebec1,
      photoM: quebec1M,
      title: 'A rising culinary destination'
    },
    {
      photo: quebec2,
      photoM: quebec2M,
      title: 'Casse-croûtes',
      copy:
        'These roadside joints are a common sight on Québécois road trips—and the perfect place to indulge in delicious, unfussy dining.'
    },
    {
      photo: quebec3,
      photoM: quebec3M,
      title: 'Old Québec',
      copy:
        'Take in over 400 years of history in this globally-renowned gem as you stroll through Petit-Champlain, one of the oldest shopping streets in North America.'
    }
  ],
  [
    {
      photo: banff1,
      photoM: banff1M,
      title: 'Rocky Mountaineer',
      copy:
        'Journey into the Canadian Rockies on a glass-domed train, the most luxurious passenger rail service on the historic route connecting Canada from east to west.',
      button: 'learn more',
      href: 'https://www.rockymountaineer.com/',
      label: 'Visit Rocky Mountaineer Home Page'
    },
    {
      photo: banff2,
      photoM: banff2M,
      title: 'Banff Gondola'
    },
    {
      photo: banff3,
      photoM: banff3M,
      title: 'Endless Hiking Trails',
      copy:
        'With over 994 miles of hiking trails, it’s impossible to get bored in Banff National Park and its surrounding area—no wonder it’s Canada’s most visited national park.'
    },
    {
      photo: banff4,
      photoM: banff4M,
      title: 'Canmore Canyon Walk',
      copy:
        'Indigenous Peoples have long had an intimate relationship with the canyons in the Banff and Jasper area, using their craggy walls as important landmarks, signs, and message boards. Join an Indigenous guide for a tour of the pictographs in these canyons—and learn about the cultural importance of landscapes like these to the original inhabitants in the area.',
      button: 'explore now',
      href: 'https://mahikan.ca/product/canmore-canyon-walk/',
      label: 'Visit Canmore Canyon Walk Page'
    }
  ],
  [
    {
      photo: yukon1,
      photoM: yukon1M,
      title: 'Northern lights',
      copy:
        'For the best views of the northern lights (aurora borealis), head out on a dark, clear night during the first few weeks of winter.'
    },
    {
      photo: yukon2,
      photoM: yukon2M,
      title: 'Historic hot springs',
      copy:
        'Used by Indigenous Peoples for centuries, Takhini Hot Springs (also called Eclipse Nordic Hot Springs) features natural mineral waters with temperatures ranging between 97 to 108 °F.',
      source: 'Eclipse Nordic Hot Springs'
    },
    {
      photo: yukon3,
      photoM: yukon3M,
      title: 'Culture and heritage',
      copy:
        'From Indigenous cultural centers to gold rush museums and beyond, a trip up north is a can’t-miss opportunity to learn about Yukon’s history, landscape, and people.'
    }
  ]
];
